// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IEoyPlanReconciliationDelayDaysPropertyDto
 */
export interface IEoyPlanReconciliationDelayDaysPropertyDto {
    /**
     * 
     * @type {number}
     * @memberof IEoyPlanReconciliationDelayDaysPropertyDto
     */
    eoy_plan_reconciliation_delay_days?: number;
    /**
     * 
     * @type {string}
     * @memberof IEoyPlanReconciliationDelayDaysPropertyDto
     */
    eoy_plan_reconciliation_delay_days_state?: IEoyPlanReconciliationDelayDaysPropertyDtoEoyPlanReconciliationDelayDaysStateEnum;
}

/**
* @export
* @enum {string}
*/
export enum IEoyPlanReconciliationDelayDaysPropertyDtoEoyPlanReconciliationDelayDaysStateEnum {
    MODIFIABLE = 'MODIFIABLE',
    LOCKED = 'LOCKED',
    HIDDEN = 'HIDDEN',
    REQUIRED_AT_PLAN = 'REQUIRED_AT_PLAN',
    REQUIRED_AT_ALL_LEVELS = 'REQUIRED_AT_ALL_LEVELS'
}


/**
 * Check if a given object implements the IEoyPlanReconciliationDelayDaysPropertyDto interface.
 */
export function instanceOfIEoyPlanReconciliationDelayDaysPropertyDto(value: object): value is IEoyPlanReconciliationDelayDaysPropertyDto {
    return true;
}

export function IEoyPlanReconciliationDelayDaysPropertyDtoFromJSON(json: any): IEoyPlanReconciliationDelayDaysPropertyDto {
    return IEoyPlanReconciliationDelayDaysPropertyDtoFromJSONTyped(json, false);
}

export function IEoyPlanReconciliationDelayDaysPropertyDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IEoyPlanReconciliationDelayDaysPropertyDto {
    if (json == null) {
        return json;
    }
    return {
        
        'eoy_plan_reconciliation_delay_days': json['eoy_plan_reconciliation_delay_days'] == null ? undefined : json['eoy_plan_reconciliation_delay_days'],
        'eoy_plan_reconciliation_delay_days_state': json['eoy_plan_reconciliation_delay_days_state'] == null ? undefined : json['eoy_plan_reconciliation_delay_days_state'],
    };
}

export function IEoyPlanReconciliationDelayDaysPropertyDtoToJSON(json: any): IEoyPlanReconciliationDelayDaysPropertyDto {
    return IEoyPlanReconciliationDelayDaysPropertyDtoToJSONTyped(json, false);
}

export function IEoyPlanReconciliationDelayDaysPropertyDtoToJSONTyped(value?: IEoyPlanReconciliationDelayDaysPropertyDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'eoy_plan_reconciliation_delay_days': value['eoy_plan_reconciliation_delay_days'],
        'eoy_plan_reconciliation_delay_days_state': value['eoy_plan_reconciliation_delay_days_state'],
    };
}

